import {drawer} from '@cypro/ui/components'
import {TradeNameDrawer} from '@/modules/products/trade-names/components/trade-name-drawer/trade-name-drawer'
import {TradeNameProvider} from '@/shared/contexts/trade-name'
import {TradeName} from '@cypro/engine/schema'
import {Suspense} from 'react'

export function getTradeNameDrawerId(tradeNameId: string) {
  return `trade-name-drawer-${tradeNameId}`
}

export function openTradeNameDrawer(tradeName: TradeName) {
  const id = getTradeNameDrawerId(tradeName.id)

  try {
    drawer.remove(id)
  } catch {}

  return drawer.open(id, {
    id,
    children: (
      <Suspense>
        {tradeName && (
          <TradeNameProvider tradeName={tradeName}>
            <TradeNameDrawer />
          </TradeNameProvider>
        )}
      </Suspense>
    ),
    contentProps: {
      'data-e2e': 'trade-name-drawer',
    },
  })
}
